"use strict";
const { formatCurrency, formatCurrencyByCurrencyCodes } = require('./formatCurrency');
const formatHealth = require('./formatHealth');
const { isNumericFormat } = require('./attributes');
module.exports = {
    isNumericFormat,
    formatCurrency,
    formatHealth,
    formatCurrencyByCurrencyCodes,
};
//# sourceMappingURL=index.js.map